import { render, staticRenderFns } from "./organ-manage.vue?vue&type=template&id=6ce50586&scoped=true&"
import script from "./organ-manage.vue?vue&type=script&lang=js&"
export * from "./organ-manage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce50586",
  null
  
)

export default component.exports